/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_E2_SubtitleInputs */

const en_visa_e2_subtitle = /** @type {(inputs: Visa_E2_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TREATY TRADERS & INVESTORS`)
};

const pt_visa_e2_subtitle = /** @type {(inputs: Visa_E2_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COMERCIANTES E INVESTIDORES POR TRATADO`)
};

const es_visa_e2_subtitle = /** @type {(inputs: Visa_E2_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COMERCIANTES E INVERSIONISTAS POR TRATADO`)
};

/**
* | output |
* | --- |
* | "TREATY TRADERS & INVESTORS" |
*
* @param {Visa_E2_SubtitleInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_e2_subtitle = /** @type {((inputs?: Visa_E2_SubtitleInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_E2_SubtitleInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_e2_subtitle(inputs)
	if (locale === "es") return es_visa_e2_subtitle(inputs)
	return en_visa_e2_subtitle(inputs)
});